import styled from 'styled-components';

export const StepFooter = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-top: auto;
	padding: 0.5rem 1rem 0;

	> * {
		flex: 1 1 0;
	}
`;
